module.exports = __webpack_public_path__ + "static/gibraltar_confectionery_logo-30f8be10bbf263d93f35d95048464a5b.png";